<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';

  import { cn, getRemainingTime } from '@shared/utils';

  export let endDate: Date;
  export let classes = '';

  const dispatcher = createEventDispatcher<{ tick: void }>();

  let intervalId: ReturnType<typeof setInterval>;

  $: remainingTime = getRemainingTime(endDate);

  onMount(() => {
    intervalId = setInterval(() => {
      remainingTime = getRemainingTime(endDate);

      dispatcher('tick');
    }, 1000);
  });

  onDestroy(() => {
    clearInterval(intervalId);
  });
</script>

<div class="{cn('w-[150px] text-[22px] font-medium leading-6 md:text-[28px]', classes)}">
  {remainingTime}
</div>
